// @flow
import type { Uploader } from "uploader";
import { selectCloudInfo } from "../store/selectors";
import { EVENT_TYPES } from "../common/events";

/**
 * emit cloud info in case it changed
 */
export default (newState: Object, prevState: Object, uploader: Uploader/* , actions: Object */) => {
	const newCloudInfo = selectCloudInfo(newState);
	const prevCloudInfo = selectCloudInfo(prevState);

	if (newCloudInfo !== prevCloudInfo) {
		uploader.emit(EVENT_TYPES.UPLOADER_CLOUD_INFO, {
			...newCloudInfo,
		});
	}
};
